import type { UserProgram } from './user-program.js';
import type { City } from './city.js';
import type { ProfessionalExperience } from './professional-experience.js';
import type { UserResume } from './user-resume.js';
import type { UserEducation } from './user-education.js';
import type { UserSkill } from './user-skill.js';
import type { UserInterest } from './user-interest.js';
import type { Organization } from './organization.js';
import type { Agency } from './agency.js';
import type { UserWishedJob } from './user-wished-job.js';
import type { WishedContractType } from './user-wished-contract-type.js';
import type { UserZoneOfSearch } from './user-zone-of-search.js';

export enum UserRole {
  ADMINISTRATOR = 'administrator',
  BENEFICIARY = 'beneficiary',
  ADVISOR = 'advisor',
}

export enum UserStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum UserOnboardingStep {
  NOT_STARTED = 0,
  GCU = 1,
  PASSWORD = 2,
  PERSONAL_INFORMATION = 3,
  ZONE_OF_SEARCH = 4,
  WISHED_JOBS = 5,
  CAREER = 6,
  SKILLS = 7,
  COMPLETED = 8,
}

export enum UserOrigin {
  SIE_AKSIS = 'SIE Aksis',
}

export interface User {
  id: number;
  nanoid: string;
  firstName: string;
  lastName: string;
  phoneNumber?: string | null;
  email: string;
  previousEmail?: string | null;
  ide?: string | null;
  role: UserRole;
  address?: string | null;
  cityName?: string | null;
  zipCode?: string | null;
  cityInsee?: string | null;
  password?: string | null;
  resetPasswordToken?: string | null;
  status: UserStatus;
  onboardingStep: UserOnboardingStep;
  gcuAccepted?: Date | null;
  origin?: UserOrigin | null;
  birthDate?: Date | null;
  carOwner?: boolean | null;
  sieId?: string | null;
  addviseoId?: string | null;
  organizationId?: number | null;
  agencyId?: number | null;
  externalId?: string | null;
  needCVDesignrAccessApproval?: boolean;
  cvdesignrCreatedAt?: Date | null;
  profileShared?: boolean;
  profileSharingManuallyDisabled?: boolean;

  // relationships
  userPrograms?: UserProgram[];
  city?: City; // from cityInsee
  professionalExperiences?: ProfessionalExperience[];
  resumes?: UserResume[];
  educations?: UserEducation[];
  skills?: UserSkill[];
  interests?: UserInterest[];
  organization?: Organization;
  agency?: Agency;
  wishedJobs?: UserWishedJob[];
  wishedContractType?: WishedContractType | null;
  zonesOfSearch?: UserZoneOfSearch[];
}
